export interface State {
  associatedUsers: string[];
}

export const initialState: State = {
  associatedUsers: [],
};
